import gql from 'graphql-tag';

export default gql`
  fragment DataPageData on DataPageData {
    uuid
    type
    itemUuid
  }
`;
